import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const usePerformanceInsight = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [PerformanceInsightData, setPerformanceInsightData] = useState<any[]>([]);

    const onPerformanceDataError = (err: AxiosError<ErrorHttpResponse>) => {
        setPerformanceInsightData([]);
    };

    const onPerformanceDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<PerformanceDataSuccessInterface[]>) => {
        setPerformanceInsightData(Array.isArray(data) ? data : []);
    };

    const getPerformanceDataInsight = (urlString: string, companyId: string) => {
        const separator = urlString.includes('?')
            ? (urlString.endsWith('?') || urlString.endsWith('&') ? '' : '&')
            : '?';

        const url: HttpConfig = {
            url: `${urlString}${separator}companyId=${encodeURIComponent(companyId)}`,
            method: 'get',

        };
        request(url, onPerformanceDataSuccess, setLoading, onPerformanceDataError);
    };

    return { getPerformanceDataInsight, loading, PerformanceInsightData };
};

export default usePerformanceInsight;



interface PerformanceDataSuccessInterface {
    dayLabel: string;
    day: string;
    weightedScore: number;
    noOfRatings: number;
}
